"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import HeaderSection from "../../layout/HeaderSection";
import CareersGrid from "./components/CareersGrid";
import Footer from "../../layout/Footer";
import { careers } from "../../../api/collections/careerApi";
import { CareerItem } from "@/types/careerType";

/**
 * Career Page Component
 * Main component for the career page displaying job listings
 */
const CareerPage: React.FC = () => {
  const router = useRouter();
  const [careersData, setCareersData] = useState<CareerItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCareers = async () => {
      try {
        setLoading(true);
        setError(null);

        // Get only active career listings
        const response = await careers.getActive();

        if (response.success && response.data) {
          setCareersData(response.data);
        } else {
          setError(
            response.error?.message || "Không thể tải dữ liệu tuyển dụng"
          );
        }
      } catch (err) {
        setError("Đã xảy ra lỗi khi tải dữ liệu tuyển dụng");
        console.error("Error fetching careers:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCareers();
  }, []);

  // Handle career click - navigate to career detail page
  const handleCareerClick = (career: CareerItem) => {
    console.log("Career clicked:", career);
    // Navigate to career detail page
    router.push(`/careers/${career.id}`);
  };

  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <HeaderSection
        title="Tuyển dụng"
        subtitle="Tham gia đội ngũ của chúng tôi và xây dựng tương lai xanh"
        backgroundImage="/header_90ad.png"
        ariaLabel="Careers page header"
        overlayOpacity="medium"
      />

      {/* Careers Grid Section */}
      <CareersGrid
        careers={careersData}
        loading={loading}
        error={error}
        onCareerClick={handleCareerClick}
      />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default CareerPage;
